<template>
  <div data-component-group="form" data-component="user-deny-reason">
    <h2>
      {{ 'Deny reason' }}
    </h2>
    <div class="editor-box">
      <base-text-editor
        :value="denyReason"
        :config="editorConfig"
        @input="onChangeDenyReason"
      />
      <p v-if="hasErrors" class="text-error">
        {{ 'The reason field is required.' }}
      </p>
    </div>

    <div class="component-actions">
      <v-btn variant="text" class="trigger cancel" @click="onCancel">
        {{ 'Cancel' }}
      </v-btn>
      <v-btn class="bg-primary trigger deny-user" @click="onSubmit">
        <v-icon> thumb_down </v-icon>
        {{ 'Deny' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import defaultEditorConfig from '../../../config/defaultEditorConfig';

  // TODO: Translate component

  export default {
    props: {
      triggerLabel: {
        type: String,
        default: 'Update',
      },
    },
    emits: ['cancel-deny-reason', 'deny-reason'],
    data() {
      return {
        denyReason: '',
        editorConfig: {
          ...defaultEditorConfig,
          placeholder: 'Type the reason here...',
        },
        hasErrors: false,
      };
    },
    methods: {
      onCancel() {
        this.$emit('cancel-deny-reason');
        this.denyReason = '';
      },
      onSubmit() {
        const { denyReason } = this;

        if (denyReason === '') {
          this.hasErrors = true;
          return false;
        }

        this.$emit('deny-reason', this.denyReason);
        this.denyReason = '';
      },
      onChangeDenyReason(denyReason) {
        this.hasErrors = denyReason === '';
        this.denyReason = denyReason;
      },
    },
  };
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='form'] {
  &[data-component='user-deny-reason'] {
    > .component-actions {
      text-align: right;
      padding: 0 0 32px 0;

      .v-btn {
        margin-top: 0;
        margin-bottom: 0;

        .v-icon {
          margin: 0 6px 0 0;
        }
      }
    }

    .editor-box {
      position: relative;

      .text-error {
        position: absolute;
        bottom: -40px;
        left: 0;
        font-size: $text-size-sm;
        color: rgb(var(--v-theme-error));
      }
    }
  }
}
</style>
